import { createStore, AnyAction } from 'redux';
import { createWrapper, HYDRATE } from 'next-redux-wrapper';
// eslint-disable-next-line import/no-extraneous-dependencies
import { composeWithDevTools } from 'redux-devtools-extension';
import combinedReducer from '../reducers';
import { RootState } from './types';

const bindMiddleware = () => {
  if (process.env.NODE_ENV !== 'production') {
    return composeWithDevTools();
  }
  return undefined;
};

const reducer = (
  state: RootState | undefined,
  action: AnyAction
): RootState => {
  if (action.type === HYDRATE) {
    return {
      ...state,
      ...action.payload
    };
  }
  return combinedReducer(
    state,
    action as Parameters<typeof combinedReducer>[1]
  );
};

const makeStore = () => createStore(reducer, bindMiddleware());

export default createWrapper<RootState>(makeStore);
